import { useMemo } from "react";
import { Chip } from "@mui/material";
import { useTranslations } from "use-intl";

import type { City } from "../lib/types/types";

type Props = {
  onRecommendationClick: (city: City) => void;
  shouldShow?: (city: City) => boolean;
};

export function CitiesRecommendations({
  onRecommendationClick,
  shouldShow,
}: Props) {
  const t = useTranslations();
  const data = useMemo<City[]>(() => {
    const commonProps = {
      countryName: t("searchRecommendations.iraq"),
      countryCode: "IQ",
      type: "CITY" as const,
    };

    const cities = [
      {
        id: "1",
        name: t("searchRecommendations.baghdad"),
        code: "BGW",
      },
      {
        id: "34",
        name: t("searchRecommendations.mosul"),
        code: "",
      },
      {
        id: "31",
        name: t("searchRecommendations.najaf"),
        code: "NJF",
      },
      {
        id: "33",
        name: t("searchRecommendations.erbil"),
        code: "EBL",
      },
      {
        id: "32",
        name: t("searchRecommendations.basra"),
        code: "BSR",
      },
    ].map((city) => ({ ...commonProps, ...city }));

    if (shouldShow) {
      return cities.filter(shouldShow);
    }

    return cities;
  }, [t, shouldShow]);

  return (
    <ul className="mt-4 -mb-2 flex w-full shrink-0 gap-2 overflow-x-auto pb-2">
      {data.map((city) => (
        <li key={city.id}>
          <Chip
            label={city.name}
            component="button"
            onClick={() => onRecommendationClick(city)}
            sx={{
              bgcolor: "var(--color-surface-background)",
              color: "var(--color-text-primary)",
              fontSize: "var(--text-sm)",
              fontWeight: "var(--font-weight-medium)",
              borderRadius: "var(--radius-xl)",
              padding: "calc(var(--spacing) * 2) calc(var(--spacing) * 4)",
              "&:hover": {
                // on Safari, hover state sometimes is applied right after drawer was opened
                // we don't want that, so we set the same background color as normal state
                bgcolor: "var(--color-surface-background)",
              },
              "& .MuiChip-label": {
                padding: 0,
              },
            }}
          />
        </li>
      ))}
    </ul>
  );
}
